import { Card, Heading } from '@appd/uik';
import { useTemplateStore } from './DashboardViewer/hooks/TemplateProvider';
import DashboardLoading from './componentVariations/loading/DashboardLoading';
import { PartialQueryResults } from '../../models/DatasourcesModels';

interface StatedContainerProps {
  id: string;
  title: string;
  children: React.ReactNode;
}

export const StatedContainer = ({ title = '', children }: StatedContainerProps) => {
  const [queryResultStatuses] = useTemplateStore(store => (store as Record<string, unknown>).queryResultStatuses);
  if (!queryResultStatuses) {
    return null;
  }

  const isLoading = (queryResultStatuses as PartialQueryResults)?.isLoading ?? false;
  const hasError = (queryResultStatuses as PartialQueryResults)?.hasError ?? false;

  return (
    <Card.Container className={{ height: '100%', boxSizing: 'border-box' }}>
      <div>
        <Heading size="SUB_SECTION">{title}</Heading>
      </div>
      {Boolean(isLoading) && <DashboardLoading />}
      {Boolean(hasError) ? <div>something went wrong</div> : children}
    </Card.Container>
  );
};
